// extracted by mini-css-extract-plugin
export default {"commonCheckbox":"Checkbox_commonCheckbox__-qZla","disabled":"Checkbox_disabled__Fbwb3","checkboxIcon":"Checkbox_checkboxIcon__V7Fim"};